//@ts-nocheck
import React from 'react'
import _ from 'lodash'
import T from 'prop-types'
import { Manager } from '@wework/floormap-sdk'
import { ManagerContext } from '@wework/react-floormap'
import forwardInnerRef from '../../hoc/forwardInnerRef'
import InventoryManager from './InventoryManager'

class SessionInventoryManager extends React.Component {
  static contextType = ManagerContext

  constructor(props, context) {
    super(props)
    this.state = {
      authenticated: false,
      session: props.session,
    }
    this.configureManager(props, context)
  }

  async componentDidMount() {
    const { onActivity, onSessionExpired, configuration } = this.props
    try {
      onActivity('MW_INITIALIZING_SESSION', {
        message: 'Initializing session',
      })
      if (configuration.spacemanToken) {
        await this.authenticateWithSpacemanToken(configuration.spacemanToken)
      } else {
        await this.manager.authenticate()
      }

      onActivity('MW_INITIALIZING_SESSION_SUCCESS', {
        message: 'Successfully initialized session',
      })

      this.setState({
        authenticated: true,
      })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`[Occupancy Map]: ${e.message}`)
      onActivity('MW_INITIALIZING_SESSION_SUCCESS', { error: e })
      onSessionExpired(e)
    }
  }

  async componentDidUpdate(prevProps) {
    const { session, configuration } = this.props
    if (
      configuration.spacemanToken &&
      prevProps.configuration.spacemanToken !== configuration.spacemanToken
    ) {
      this.authenticateWithSpacemanToken(configuration.spacemanToken)
      return
    }

    if (session && prevProps.session !== session) {
      this.manager.session.setAccessToken(session.milkyway_token)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ session })
    }
  }

  configureManager = (props, context) => {
    const { configuration, session, manager } = props
    const { spacemanToken, appId, appSecret, baseUrl } = configuration
    let mwAccessToken

    if (session && session.milkyway_token) {
      mwAccessToken = session.milkyway_token
    }

    const authOptions = {
      appId,
      appSecret,
      baseUrl,
      mwAccessToken,
      spacemanToken,
    }

    this.manager = manager || context

    if (!this.manager) {
      this.manager = new Manager(authOptions)
    }

    if (mwAccessToken) {
      this.manager.session.setAccessToken(mwAccessToken)
    }
  }

  authenticateWithSpacemanToken = async spacemanToken => {
    // Emit event if first authenticated
    const { authenticated } = this.state
    const {
      onSessionExpired,
      onActivity,
      onLoading,
      configuration,
    } = this.props
    if (!authenticated) {
      onActivity('MW_INITIALIZING_SESSION', {
        message: 'Initializing session',
      })
      onLoading({ loading: true })
    }

    try {
      const payload = {
        grant_type: 'spaceman_token',
        client_id: configuration.appId,
        user_details: { spaceman_token: spacemanToken },
      }

      const response = await this.manager.getClient().post('/auth', payload)
      if (!response.meta.success) {
        throw new Error(response.meta.message)
      }

      const session = _.get(response, 'data.attributes')
      const mwAccessToken = session.milkyway_token
      this.manager.session.setAccessToken(mwAccessToken)

      this.setState({
        session: _.get(response, 'data.attributes'),
        authenticated: true,
      })

      // Emit event if first authenticated
      if (!authenticated) {
        onActivity('MW_INITIALIZING_SESSION_SUCCESS', {
          message: 'Successfully initialized session',
        })
        onLoading({ loading: false })
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`[Occupancy Map]: ${e.message}`)
      // eslint-disable-next-line no-console
      console.error(e)
      onSessionExpired(e.message)
      onLoading({ loading: false, error: e })
    }
  }

  render() {
    const { authenticated, session } = this.state
    const { innerRef, ...restProps } = this.props
    if (!authenticated) {
      return null
    }

    return (
      <InventoryManager
        {...restProps}
        ref={innerRef}
        session={session}
        manager={this.manager}
      />
    )
  }
}

SessionInventoryManager.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  session: T.object,
  onActivity: T.func,
  onLoading: T.func,
  onSessionExpired: T.func,
  configuration: T.shape({
    appId: T.string.isRequired,
    appSecret: T.string,
    baseUrl: T.string.isRequired,
    spacemanToken: T.string,
    stargateUrl: T.string,
  }).isRequired,
  innerRef: T.any,
}

const NOOP = () => {}
SessionInventoryManager.defaultProps = {
  session: null,
  onActivity: NOOP,
  onLoading: NOOP,
  onSessionExpired: NOOP,
  innerRef: null,
}

export default forwardInnerRef(SessionInventoryManager)
